import * as React from 'react';
import { useEffect } from 'react';
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { DateUtil } from "../../fxms/datas/DateUtil";

/* 공장대시보드 에너지사용량 : 실시간 에너지 사용공급현황 */
export const FxDashChart2ConsProd = (props) => {
  const { energy, allValues , isDetailView, onDetailView } = props;
  const unitSuffix = energy === "AIR" ? "Nm3/h" : energy === "STEAM" ? "kg/h" : "";
  //console.log("*** FxDashChart2ConsProd ***", energy, "allValues", allValues);
  const makeSeries = () => {

    const series = [];
    const values = allValues[energy];
    if (values) {
      const s = {};
      s.name = '유량(공급)';
      s.type = 'areaspline';
      s.data = [];
      s.color = '#8ce690';
      s.lineWidth = 2.2;
      s.marker = { enabled: false };
      s.fillColor = {
        linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
        stops: [
          [0, "rgba(140, 230, 144, 0.28)"],
          [1, "rgba(140, 230, 144, 0.03)"],
        ],
      };
      s.states = { hover: { lineWidthPlus: 0 } };

      const s2 = {};
      s2.name = '유량(사용)';
      s2.type = 'areaspline';
      s2.data = [];
      s2.color = '#39c9e5';
      s2.lineWidth = 2.2;
      s2.marker = { enabled: false };
      s2.fillColor = {
        linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
        stops: [
          [0, "rgba(57, 201, 229, 0.25)"],
          [1, "rgba(57, 201, 229, 0.02)"],
        ],
      };
      s2.states = { hover: { lineWidthPlus: 0 } };

      if (values !== undefined) {
        for (const data of values) {
          s.data.push([DateUtil.makeDate(data.psDate).getTime(), data.prodInstVal]);
          // if (energy === 'STEAM' || energy === 'AIR') {
          //   s2.data.push([DateUtil.makeDate(data.psDate).getTime(), data.consPresVal]);
          // } else if (energy === 'COOLWATER') {
          //   s2.data.push([DateUtil.makeDate(data.psDate).getTime(), data.consTempVal]);
          // }
          s2.data.push([DateUtil.makeDate(data.psDate).getTime(), data.consInstVal]);
        }
      }
      series.push(s);
      series.push(s2);
    }
    return series;
  }

  const getChartData = (title) => {
    return {
      title: {
        text: title,
        align: "center",
      },

      tooltip: {
        crosshairs: true,
        shared: true,
        valueSuffix: " ",
        backgroundColor: "rgba(19, 26, 40, 0.96)",
        borderColor: "#4fc3f7",
        borderWidth: 1,
        borderRadius: 8,
        style: {
          color: "#edf4ff",
          fontSize: "12px",
        },
        formatter: function () {
          let tooltip = '<span style="font-size: 11px;color:#9eb9e8">' + Highcharts.dateFormat('%Y년 %m월 %d일 %H시 %M분', this.x) + '</span><br/>';
          this.points.forEach(function (point) {
            tooltip += '<span style="color:' + point.series.color + '">●</span> ' + point.series.name + ': <b>' + Highcharts.numberFormat(point.y || 0, 2) + '</b> ' + unitSuffix + '<br/>';
          });
          return tooltip;
        }
      },
      plotOptions: {
        series: {
          animation: {
            duration: 450,
          },
          cursor: 'pointer',
          linecap: "round",
          point: {
            events: {
              click: (e) => {
                // 데이터 포인트 클릭 시
                console.log("*** click ***", e);
                if (onDetailView) {
                  console.log("*** onDetailView ***", onDetailView);
                  onDetailView(e);
                }
              }
            }
          }
        },
        areaspline: {
          threshold: null,
          linecap: "round",
        }
      },
      xAxis: {
        type: "datetime",
        min: (() => {
          const today = new Date();
          return new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0, 0).getTime();
        })(),
        max: (() => {
          const today = new Date();
          return new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59, 999).getTime();
        })(),
        labels: {
          style: {
            color: "rgba(229,239,255,0.82)"
          },
          formatter: function () {
            return new Date(this.value).toLocaleTimeString('ko-KR', { hour: "numeric", hour12: false });
          }
        },
        tickInterval: 3 * 60 * 60 * 1000,
        lineColor: "rgba(102, 118, 153, 0.55)",
        tickColor: "rgba(102, 118, 153, 0.55)",
        crosshair: {
          color: "rgba(141, 167, 214, 0.45)",
          dashStyle: "ShortDot",
        },
      },
      yAxis: {
        title: {
          text: null,
        },
        labels: {
          style: {
            color: "rgba(211, 223, 247, 0.75)",
            fontSize: "11px",
          },
        },
        lineWidth: 1,
        lineColor: '#3e3e3e',
        gridLineColor: 'rgba(115, 131, 171, 0.30)',
        gridLineDashStyle: 'ShortDot',
      },
      chart: {
        backgroundColor: "#2f3440",
        borderWidth: 0,
        borderRadius: 0,
        borderColor: "#303030",
        plotBackgroundColor: "#2d323d",
        plotBorderWidth: 0,
        plotBorderColor: "#303030",
        events: {
          click: (e) => {
            if (onDetailView) {
              console.log("*** onDetailView 2222 ***", onDetailView);
              onDetailView(e);
            }
          },
          render: function () {
            if (this.wheelEventAdded) return;
            this.wheelEventAdded = true;
            this.container.addEventListener('wheel', (event) => {
              event.preventDefault();
              const chart = this;
              const xAxis = chart.xAxis[0];
          
              // 오늘 0시~24시
              const today = new Date();
              const startOfDay = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0, 0).getTime();
              const endOfDay = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59, 999).getTime();

              // 마우스 위치 → x축 값
              const rect = chart.container.getBoundingClientRect();
              const mouseX = event.clientX - rect.left;
              const xValue = xAxis.toValue(mouseX, true);
          
              const min = xAxis.min;
              const max = xAxis.max;
              const range = max - min;
          
              // 커서가 차지하는 비율
              const ratio = (xValue - min) / range;
          
              // 줌 인/아웃 비율
              const zoomFactor = event.deltaY < 0 ? 0.8 : 1.25;
              const newRange = range * zoomFactor;
          
              // 커서 위치 고정 계산
              let newMin = xValue - newRange * ratio;
              let newMax = xValue + newRange * (1 - ratio);
          
               // 최대 축소 상태라면 전체 24시간으로 리셋
              if (newMin <= startOfDay && newMax >= endOfDay) {
                xAxis.setExtremes(startOfDay, endOfDay, true, false);
              } else {
                xAxis.setExtremes(newMin, newMax, true, false);
              }
            });
          }
        }
      },
      credits: {
        enabled: false,
      },
      series: makeSeries()
      ,
      legend: {
        enabled: true,
        layout: 'horizontal',
        align: 'center',     
        verticalAlign: 'bottom', 
        itemStyle: {
          color: '#fff',
          fontWeight: '700',
        },
        symbolWidth: 12,
        symbolRadius: 6,
        symbolPadding: 8,
        useHTML: false,
        labelFormatter: function () {
          return this.name;
        },
      }
    };
  }

  useEffect(() => {
    const values = allValues[energy];
    if (values === undefined) {
      return;
    }
  }, [allValues, energy])

  return (
    <HighchartsReact
      containerProps={{
        style: {
          height: isDetailView ? "450px" : "220px",
          width: "100%",
          borderRadius: "10px",
          overflow: "hidden",
        },
      }}
      highcharts={Highcharts}
      options={getChartData('', '', '', '')}
    />
  );
}
